import axios from "axios";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import CriticalIcon from "../assets/icon/CriticalIcon";
import StableIcon from "../assets/icon/CriticalIcon copy";
import HeartRateIcon from "../assets/icon/HeartRateIcon";
import PatientIcon from "../assets/icon/PatientIcon";
import { useAuth } from "../context/AuthContext";
import AppointmentTable from "./Appointment/AppointmentTable";
import { StatsCard } from "./shared/statscard";

interface AppointmentStats {
  today: number;
  upcoming: number;
  completed: number;
  cancelled: number;
  total: number;
}

export const AppointmentLayout = () => {
  const [stats, setStats] = useState<AppointmentStats>({
    today: 0,
    upcoming: 0,
    completed: 0,
    cancelled: 0,
    total: 0,
  });
  const [, setLoading] = useState(true);
  const { user } = useAuth();

  const fetchAppointmentStats = useCallback(async () => {
    try {
      const token = (user as any)?.token || localStorage.getItem('token') || '';
      
      if (!token) {
        console.error("No token found");
        setLoading(false);
        return;
      }

      const BASE_URL = 'https://vivotal-backend.vercel.app/api/v1';
      
      const axiosResponse = await axios.get(`${BASE_URL}/appointments?limit=100&page=1`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const appointments = axiosResponse.data?.data || [];
      
      // Get today's date
      const today = dayjs().format("YYYY-MM-DD");
      const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

      let todayCount = 0;
      let upcomingCount = 0;
      let completedCount = 0;
      let cancelledCount = 0;

      appointments.forEach((apt: any) => {
        const appointmentDate = new Date(apt.appointment_date);
        const formattedDate = appointmentDate.toISOString().split('T')[0];

        // Count by status
        if (apt.status === "COMPLETED") {
          completedCount++;
        } else if (apt.status === "CANCELLED") {
          cancelledCount++;
        } else if (formattedDate === today) {
          // Today's appointments (any non-cancelled status)
          todayCount++;
        } else if (formattedDate >= tomorrow && (apt.status === "PENDING" || apt.status === "CONFIRMED")) {
          // Upcoming appointments
          upcomingCount++;
        }
      });

      const totalAppointments = appointments.length;

      setStats({
        today: todayCount,
        upcoming: upcomingCount,
        completed: completedCount,
        cancelled: cancelledCount,
        total: totalAppointments,
      });
    } catch (err) {
      console.error("Error fetching appointment stats:", err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchAppointmentStats();
  }, [fetchAppointmentStats]);

  return (
    <>
      <div className="section" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div className="heading">Appointments</div>

          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <button
              className="outline-bttn"
              style={{ justifyContent: "center" }}
            >
              Export
            </button>

            <button className="success-bttn">
              <span style={{ fontSize: "20px" }}>+</span> Create appointment
            </button>
          </div> */}
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexBasis: "1",
            marginBottom: "20px",
          }}
        >
          <StatsCard
            count={stats.today}
            label="Today's"
            icon={<PatientIcon width={24} height={24} color="#A0AEC0" />}
            color="#4FD1C5"
          />

          <StatsCard
            count={stats.upcoming}
            label="Upcoming"
            icon={<HeartRateIcon width={24} height={24} color="#A0AEC0" />}
            color="#FFA94D"
          />

          <StatsCard
            count={stats.completed}
            label="Completed"
            icon={<StableIcon width={24} height={24} color="#A0AEC0" />}
            color="#1FB551"
          />

          <StatsCard
            count={stats.cancelled}
            label="Canceled"
            icon={<CriticalIcon width={24} height={24} color="#A0AEC0" />}
            color="#EE0F12"
          />
        </div>

        <div>
          <AppointmentTable />
        </div>
      </div>
    </>
  );
};
